import React, { useEffect, useState } from "react";
import { useTranslation } from "../../i18n/TranslationProvider";

import {
  Switch,
  Route,
  NavLink,
  useRouteMatch,
  useLocation,
} from "react-router-dom";

import { Row, Col, Nav } from "react-bootstrap/";
import Sallie from "../Sallie";
import ChangeNotification from "./ChangeNotification";

const AccountSetting = () => {
  let { path, url } = useRouteMatch();
  const location = useLocation();
  const { t, language } = useTranslation();
  let optionName = location.pathname.slice(16);
  const [sallieText, setSallieText] = useState("");
  const [isSuccess, setIsSuccess] = useState(undefined);

  useEffect(() => {
    if (isSuccess) {
      setSallieText(t("accountSettings.sallieSettings.success"));
    } else if (isSuccess === false) {
      setSallieText(t("accountSettings.sallieSettings.error"));
    } else if (optionName === "ChangeNotification" && isSuccess === undefined) {
      setSallieText(t("accountSettings.sallieSettings.notification"));
    } else {
      setSallieText(t("accountSettings.sallieSettings.default"));
    }
  }, [isSuccess, optionName, language]);

  return (
    <Row>
      <Col>
        <Sallie text={sallieText} />
        <Row className="d-flex justify-content-around">
          <Col md={3} className="accountSettingNav">
            <Nav variant="pills" className="flex-column">
              <Nav.Link
                eventKey={`${url}/ChangeNotification`}
                as={NavLink}
                to={`${url}/ChangeNotification`}
              >
                {t("accountSettings.settings.notification")}
              </Nav.Link>
            </Nav>
          </Col>
          <Col
            md={8}
            className="d-flex justify-content-center align-items-center"
          >
            <Switch>
              <Route path={`${path}/ChangeNotification`}>
                <ChangeNotification setIsSuccess={setIsSuccess} />
              </Route>
            </Switch>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default AccountSetting;